import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LangButton from "../../components/languagesButton";

const RemindPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      await axios.post(
        process.env.REACT_APP_BACKEND_URL + "/api/admin/forgot-password",
        { email }
      );
      setMessage(t("password_reset_instructions_sent"));
    } catch (err) {
      setError(err.response?.data?.message || t("failed_to_send_email"));
    }
  };
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  };
  const handleBackToLogin = () => {
    navigate("/login");
  };
  return (
    <Box>
      <Grid container rowSpacing={1} height="100vh">
        <Grid
          size={5}
          bgcolor="#0d1b2a"
          color="#cbd5e1"
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Box textAlign="center">
            <img
              src="/assets/icons/main-logo-blue.png"
              alt="Logo"
              style={{ width: 100, marginBottom: 50 }}
            />
            <Typography variant="h3" gutterBottom style={{ margin: "20px" }}>
              {t("welcome")}
            </Typography>
            <Typography
              variant="h6"
              sx={{ opacity: 0.7 }}
              style={{ margin: "20px" }}
            >
              {t("loginMessage")}
            </Typography>
            <LangButton/>
            {/* <Box
              sx={{
                mt: 4,
                display: "flex",
                justifyContent: "center",
                fontSize: "1rem",
                fontWeight: 500,
                color: "#94a3b8",
                gap: 1,
              }}
            >
              <Button
                onClick={() => changeLanguage("ar")}
                sx={{
                  minWidth: "auto",
                  px: 1,
                  color: currentLang === "en" ? "#00b4d8" : "#94a3b8",
                  textTransform: "none",
                  fontWeight: currentLang === "en" ? 600 : 400,
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#00b4d8",
                  },
                }}
              >
                {t("arabic")}
              </Button>
              <span>|</span>
              <Button
                onClick={() => changeLanguage("en")}
                sx={{
                  minWidth: "auto",
                  px: 1,
                  color: currentLang === "ar" ? "#00b4d8" : "#94a3b8",
                  textTransform: "none",
                  fontWeight: currentLang === "ar" ? 600 : 400,
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#00b4d8",
                  },
                }}
              >
                {t("english")}
              </Button>
            </Box> */}
          </Box>
        </Grid>
        <Grid
          size={7}
          bgcolor="#12233a"
          color="#cbd5e1"
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Container maxWidth="xs">
            <Typography variant="h4" align="center" gutterBottom>
              {t("remind_password")}
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
              <TextField
                label={t("email")}
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                InputProps={{
                  style: { color: "#cbd5e1" },
                }}
                InputLabelProps={{
                  style: { color: "#90a4ae" },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#90a4ae", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#00b4d8", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00b4d8", // Border color when focused
                    },
                  },
                }}
                margin="normal"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 2,
                  backgroundColor: "#00b4d8",
                  "&:hover": { backgroundColor: "#0096c7" },
                }}
              >
                {t("send_reset_link")}
              </Button>

              {message && (
                <Typography color="success.main" align="center" sx={{ mt: 2 }}>
                  {message}
                </Typography>
              )}
              {error && (
                <Typography color="error" align="center" sx={{ mt: 2 }}>
                  {error}
                </Typography>
              )}

              <Button
                fullWidth
                variant="text"
                onClick={handleBackToLogin}
                sx={{ mt: 2, color: "#90e0ef", textTransform: "none" }}
              >
                {t("back_to_login")}
              </Button>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RemindPasswordPage;
